class Hotspots extends HTMLElement {
  constructor() {
    super();

    this.isTouch = window.matchMedia("(max-width: 989px)").matches;
    this.hotspots = this.querySelectorAll(".js-hotspot");
    this.close = this.querySelector(".js-popover-close");

    this.addListeners();
    this.placeHotspots();
  }

  addListeners() {
    this.hotspots.forEach((hotspot) =>
      hotspot.addEventListener("click", () => this.togglePopover(hotspot))
    );

    if (this.isTouch)
      this.close.addEventListener("click", (event) => this.closePopover(event));
  }

  placeHotspots() {
    this.hotspots.forEach((hotspot) => {
      const type = this.isTouch ? "locationMobile" : "location";
      const coords = hotspot.dataset[type].split(",");
      const popup = hotspot.querySelector(".hotspot__popup");

      hotspot.style = `left: ${coords[0]}%; top: ${coords[1]}%;`;

      if (!this.isTouch) this.positionPopup(hotspot, coords[0]);

      const rightDiff =
        hotspot.offsetLeft +
        popup.clientWidth / 2 -
        this.parentElement.clientWidth;
      const leftDiff = hotspot.offsetLeft - popup.clientWidth / 2;

      if (rightDiff > 0) {
        //pop up is over right
        popup.style.left = (155 + rightDiff) * -1 + "px";
      } else if (leftDiff < 0) {
        //pop up is over left
        popup.style.left = (145 + leftDiff) * -1 + "px";
      }
    });
  }

  positionPopup(hotspot, posLeft) {
    const popup = hotspot.querySelector(".hotspot__popup");

    if (posLeft > 50) popup.classList.add("hotspot__popup--left");
  }

  togglePopover(clickedHotspot) {
    if (this.isTouch) document.body.classList.toggle("shadow--body");

    this.hotspots.forEach((hotspot) => {
      hotspot === clickedHotspot
        ? hotspot.classList.toggle("hotspot--active")
        : hotspot.classList.remove("hotspot--active");
    });

    if (hotspot.dataset.id) {
      this.triggerCarousel(hotspot);
    }
  }

  triggerCarousel(hotspot) {
    const hotspotId = hotspot.dataset.id;
    const matchingSlide = document.getElementById(hotspotId);
    matchingSlide.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }

  closePopover(event) {
    event.stopPropagation();

    const hotspot = event.target.closest(".hotspot");

    this.togglePopover(hotspot);
  }
}

customElements.define("hot-spots", Hotspots);
